import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { format } from 'date-fns';
import AccordionSummary from 'feature/dispatching/components/AccordionSummary';

const accordionStyles = {
  border: 1,
  borderColor: 'graphic.light',
  boxShadow: 'none',
};
const accordionDetailsStyles = {
  backgroundColor: 'surface.white',
  p: 0,
  pl: 1,
  pr: 1.5,
};

const TrailerUpdates = ({ updates }) => {
  const dateReformat = date => format(new Date(date), "LLLL d, y 'at' h:ma 'CST'");
  return (
    <Accordion sx={accordionStyles}>
      <AccordionSummary count={updates.length} label="Trailer Updates" />
      <AccordionDetails sx={accordionDetailsStyles}>
        {updates.map(({ lastUpdated, message, status }) => (
          <ListItem key={lastUpdated}>
            <ListItemText
              primary={message}
              secondary={dateReformat(lastUpdated)}
              slotProps={{
                primary: {
                  color: status === 'ERROR' ? 'error.main' : 'gray.main',
                  mb: 1 / 2,
                  variant: 'caption',
                },

                secondary: {
                  color: 'text.primary',
                  fontWeight: '700',
                  variant: 'subtitle2',
                },
              }}
            />
          </ListItem>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

TrailerUpdates.propTypes = {
  updates: PropTypes.arrayOf(PropTypes.shape({})),
};
TrailerUpdates.defaultProps = {
  updates: [],
};

export default TrailerUpdates;
